module.exports = __webpack_public_path__ + "static/media/icon-artdirection.aaccaa32.svg";